export interface FooterNavProps {}

export const FooterNav = (props: FooterNavProps): JSX.Element => (
  <>
    <footer {...props}>
      <nav>TBD</nav>
    </footer>
  </>
)

export default FooterNav
